import React, { FunctionComponent } from 'react';
import { GeneralOverviewPageRenderedComponentProps } from '../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../utilityComponents/QueryBoundary';
import GridItem from '../../layout/GridComponents/GridItem';
import RSCard from '../../ui/containers/RSCard';
import {
  AggregationData,
  useAggregationQuery,
} from '../../../api/rs-hg/macro';
import AggregationTables from './components/AggregationTables';


const AggregationContent: FunctionComponent<{ data: AggregationData }> = ({
  data,
}) => (
  <GridItem xs={12}>
    <RSCard>
      <div className="border-b border-gray-200 pb-2">
        <h1 className="text-2xl font-bold tracking-tight text-mainblue">
          Group Aggregation
        </h1>
      </div>

      <div className="mt-4">
        <AggregationTables data={data} />
      </div>
    </RSCard>
  </GridItem>
);

const AggregationPage: FunctionComponent<
  GeneralOverviewPageRenderedComponentProps
> = () => {
  const { data, isLoading, error } = useAggregationQuery();

  return (
    <QueryBoundary
      isLoading={isLoading}
      isError={!!error}
      error={error}
      data={data}
      loadingMessages={[
        'Loading aggregation...',
        'Summarising group AUM...',
        'Preparing ManCo breakdown...',
      ]}
      errorMessage={
        error
          ? (error as Error).message ||
            'An unexpected error occurred while fetching aggregation data.'
          : 'An unexpected error occurred while fetching aggregation data.'
      }
      noDataMessage="There is no aggregation data available."
    >
      {(aggregationData) => <AggregationContent data={aggregationData} />}
    </QueryBoundary>
  );
};

export default AggregationPage;
